import { API_BASE_URL } from "../config/api";

export const RATE_LIMIT_MESSAGE =
  "تعداد درخواست‌های شما بیش از حد مجاز است. لطفاً کمی صبر کنید و دوباره تلاش کنید.";

export const RATE_LIMIT_EVENT = "api-rate-limit";

let isInstalled = false;
let lastNotificationAt = 0;

const isBackendRequest = (input) => {
  const requestUrl = input instanceof Request ? input.url : String(input);

  try {
    return new URL(requestUrl, window.location.origin).href.startsWith(
      new URL(API_BASE_URL, window.location.origin).href,
    );
  } catch {
    return false;
  }
};

export const installRateLimitHandler = () => {
  if (isInstalled || typeof window === "undefined") return;

  isInstalled = true;
  const originalFetch = window.fetch.bind(window);

  window.fetch = async (...args) => {
    const response = await originalFetch(...args);

    if (response.status === 429 && isBackendRequest(args[0])) {
      const now = Date.now();

      // Several widgets may fetch together; show one useful message instead of a
      // stack of identical notifications.
      if (now - lastNotificationAt > 1000) {
        lastNotificationAt = now;
        window.dispatchEvent(
          new CustomEvent(RATE_LIMIT_EVENT, {
            detail: { message: RATE_LIMIT_MESSAGE },
          }),
        );
      }
    }

    return response;
  };
};
